import { render, staticRenderFns } from "./AwsInputImage.vue?vue&type=template&id=0c387ebf"
import script from "./AwsInputImage.vue?vue&type=script&lang=js"
export * from "./AwsInputImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports